import {
  dndPromotion,
  getAwardSrcById
} from "../../setup/js/_promotion";
$(document).on(
  "jx1_sinhnhat_19nam_vongquay rendered", {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    if ($(".action").length > 0) {
      dndPromotion({
        url: domain,
        debug: false,
        wait: 0,
        directory: "https://img.zing.vn/products/jx1/landing/2024-sinh-nhat-19-nam/prod/jx1_sinhnhat_19nam/required_popup/images/qua",
        items: {
          length: 27,
          type: "png",
        },
        names: [],
        callback: function () {},
        animBefore: function () {
          $(".action__open").addClass("off");
        },
        animResult: function (listPrize) {
          if (typeof LuckyDrawExchangeModule !== "undefined") {
            LuckyDrawExchangeModule.fetchViewData();
          }

          const $gifts = $(".effect__item");
          let currentGift = 0;
          let interval;

          function getRandomGift() {
            return Math.floor(Math.random() * $gifts.length);
          }

          function highlightGift(index) {
            $gifts.removeClass("active");
            $($gifts[index]).addClass("active");
          }

          function startRandomHighlighting() {
            interval = setInterval(() => {
              currentGift = getRandomGift();
              highlightGift(currentGift);
            }, 400);
          }

          function stopRandomHighlighting() {
            clearInterval(interval);
            highlightGift(currentGift);
            setTimeout(() => {
              $("#popup_reward_wish").addClass("active");
              $(".action__open").removeClass("off");
            }, 700);
          }

          startRandomHighlighting();

          setTimeout(() => {
            stopRandomHighlighting();
          }, 3000); // Dừng sau 3 giây
        },

        animWait: function () {},
      });

      window["getAwardSrcById"] = getAwardSrcById;
    }
  }
);